import { apiFetcher } from "./apiFetcher";
import { versioningWixService } from "./versioning.wix.service";
import _ from 'lodash'

const categoriesPerPage = 100

/** Wix category tree reference — Wix Stores always uses this. */
const STORES_TREE_REFERENCE = { appNamespace: '@wix/stores', treeKey: null };

export const categoriesService = {
  getCategories,
  getAllCategories
};

function getCategories(page) {
  const url = `stores/v1/collections/query`

  const body = {
    query: {
      paging: {
        offset: (page-1) * categoriesPerPage
      }
    }
  }

  return apiFetcher(url, { method: "POST", body: JSON.stringify(body) });
}

// Detect the catalog version and page through categories accordingly. V1 returns
// `collections` (offset paging); V3 returns `categories` (cursor paging + treeReference).
// Both resolve to a flat array of category objects with `{ id, name, visible }`.
function getAllCategories(page = 1, categoriesArray = []) {
  return versioningWixService.getCatalogVersion().then((version) =>
    version === 'V3'
      ? getAllCategoriesV3()
      : getAllCategoriesV1(page, categoriesArray),
  );
}

function getAllCategoriesV1(page = 1, categoriesArray = []) {
  return getCategories(page)
    .then(response => {
      categoriesArray = categoriesArray.concat(response?.collections);
      page += 1;
      if(!_.isEmpty(response?.collections)){
        return getAllCategoriesV1(page, categoriesArray);
      }else{
        return categoriesArray
      }
    })
    .catch(() => {
      return categoriesArray;
    })
}

function getAllCategoriesV3(cursor = null, categoriesArray = []) {
  const body = {
    query: { cursorPaging: { limit: categoriesPerPage, ...(cursor ? { cursor } : {}) } },
    treeReference: STORES_TREE_REFERENCE,
    returnNonVisibleCategories: false,
  };

  // The V3 Categories API lives on its own host/path (NOT under stores/v3).
  return apiFetcher(`categories/v1/categories/query`, { method: "POST", body: JSON.stringify(body) })
    .then((response) => {
      const batch = (response?.categories || []).filter((c) => c.visible !== false);
      categoriesArray = categoriesArray.concat(batch);
      const next = _.get(response, 'pagingMetadata.cursors.next', null);
      if (_.get(response, 'pagingMetadata.hasNext') && next) {
        return getAllCategoriesV3(next, categoriesArray);
      }
      return categoriesArray;
    })
    .catch(() => categoriesArray);
}
